/**
 * TabPodmiot — Zakładka "Podmiot" — NIP firmy + środowisko (na sztywno PROD).
 *
 * Props:
 *   - savedNip (string)
 *   - environment (string)
 *   - onNipSaved (callback)
 */
import { CheckCircle } from "lucide-react";
import { Label } from "@/components/ui/label";
import { NipForm } from "../components/NipForm";

export const TabPodmiot = ({ savedNip, environment = "PROD", onNipSaved }) => {
  return (
    <div className="space-y-6" data-testid="tab-podmiot">
      <div>
        <h3 className="text-sm font-semibold text-gray-700 mb-1">NIP podmiotu</h3>
        <p className="text-xs text-gray-500 mb-3">
          NIP firmy, dla której pobierasz faktury z Krajowego Systemu e-Faktur.
        </p>
        <NipForm initialNip={savedNip} onSaved={onNipSaved} />
      </div>

      <div className="border-t border-gray-100 pt-6">
        <Label className="text-sm font-medium text-gray-700">Środowisko API</Label>
        <div className="mt-2 flex items-center gap-2 p-3 bg-green-50 border border-green-200 rounded-lg">
          <CheckCircle className="w-4 h-4 text-green-600" />
          <span className="text-sm font-medium text-green-800">
            {environment === "PROD" ? "PRODUKCJA" : environment}
          </span>
          <span className="text-xs text-green-600 ml-1">(ksef.mf.gov.pl)</span>
        </div>
        <p className="text-xs text-gray-500 mt-2">
          Aplikacja pracuje wyłącznie z produkcyjnym środowiskiem KSeF.
        </p>
      </div>
    </div>
  );
};

export default TabPodmiot;
